import React from 'react';
import { useIntl } from 'react-intl';
import { Text, StyleSheet, View } from 'react-native';
import Button from '../Common/Button';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonContainer: {
    width: 100,
    marginTop: 16
  }
});

const NotFound = props => {
  const intl = useIntl();

  return (
    <View style={styles.container}>
      <Text>{intl.formatMessage({ id: 'notFoundMessage' })}</Text>
      <View style={styles.buttonContainer}>
        <Button
          title={intl.formatMessage({ id: 'goBack' })}
          onPress={() => {
              props.history.goBack();
          }}
        />
      </View>
    </View>
  );
};

export default NotFound;
